module.exports = __webpack_public_path__ + "static/media/ld_logo_header.33622622.svg";